import styled, { css } from 'styled-components'
import { palette } from '@centivo/react-components'

export const PorlivpContainer = styled.div`
  grid-column: 1 / span 2;
  width: 100%;

  > p {
    text-align: center;
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          margin: '0.5rem 0 0 0',
        }
      default:
        return {
          margin: '1rem 0 0 0',
        }
    }
  }}
`

export const PorlivpButton = styled.button<{ isOpen?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: transparent;
  border: none;
  font-size: 0.75rem;
  font-weight: bold;
  cursor: pointer;
  color: ${palette.brand.newPurple};
  border-top: 1px solid ${palette.brand.lightPurple};
  ${({ theme, isOpen }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          font-size: 1.125rem;
          font-weight: 500;
          padding: 0.5rem 0;

          > svg {
            color: ${isOpen
              ? theme.palette.brand.orange
              : theme.palette.brand.newPurple} !important;
          }
        `
      default:
        return {
          fontWeight: 700,
          padding: '0.875rem 0 0.375rem 0',
        }
    }
  }}

  span {
    font-weight: inherit;
  }

  svg {
    color: inherit;
  }
`
